import React, { SVGProps } from 'react';

const SvgOptics = (props: SVGProps<SVGSVGElement>) => (
    <svg width={30.215} viewBox="0 0 30.215 9" {...props}>
        <path
            data-name="Path 807"
            d="M8.622 8.442a5.2 5.2 0 0 1-6.128-5.114V1.986A1.514 1.514 0 0 1 4.008.472h8.072a1.514 1.514 0 0 1 1.514 1.514v.5a6.055 6.055 0 0 1-4.972 5.956Z"
            fill="#12b05e"
        />
        <path
            data-name="Path 808"
            d="M5.518 6.004A5.547 5.547 0 0 1 10.683.473H4.006a1.514 1.514 0 0 0-1.514 1.514v1.342a5.192 5.192 0 0 0 3.5 4.906 5.526 5.526 0 0 1-.474-2.231Z"
            fill="#03984b"
        />
        <path
            data-name="Path 809"
            d="M21.593 8.442a5.2 5.2 0 0 0 6.128-5.114V1.986A1.514 1.514 0 0 0 26.207.472h-8.074a1.514 1.514 0 0 0-1.514 1.514v.5a6.055 6.055 0 0 0 4.974 5.956Z"
            fill="#12b05e"
        />
        <path
            data-name="Path 810"
            d="M19.647 6.004A5.547 5.547 0 0 1 24.812.473h-6.677a1.514 1.514 0 0 0-1.514 1.514v.5a6.055 6.055 0 0 0 3.368 5.424 5.528 5.528 0 0 1-.342-1.907Z"
            fill="#03984b"
        />
        <g data-name="Group 259" fill="#959cb5">
            <path
                data-name="Path 811"
                d="M.978 1.463a.5.5 0 0 0-.5.5v.5a1.009 1.009 0 0 0 1.009 1.009h1.009V1.453H.978Z"
            />
            <path
                data-name="Path 812"
                d="M29.237 1.463h-1.514v2.019h1.009a1.009 1.009 0 0 0 1.009-1.009v-.5a.5.5 0 0 0-.504-.51Z"
            />
        </g>
        <path
            data-name="Path 813"
            d="M29.237 1.009h-1.3A1.988 1.988 0 0 0 26.208 0H4.006a1.988 1.988 0 0 0-1.729 1.009H.978A.979.979 0 0 0 0 1.987v.5a1.484 1.484 0 0 0 1.482 1.482h.573A5.666 5.666 0 0 0 8.7 8.908a6.526 6.526 0 0 0 5.2-4.975 1.231 1.231 0 0 1 2.4 0 6.527 6.527 0 0 0 5.2 4.976 5.671 5.671 0 0 0 6.649-4.934h.573a1.484 1.484 0 0 0 1.482-1.482v-.5a.979.979 0 0 0-.967-.984Zm-27.219.978v1.041h-.536a.537.537 0 0 1-.536-.536v-.5a.031.031 0 0 1 .032-.031h1.041v.026Zm11.1.5A5.58 5.58 0 0 1 8.534 7.98a4.725 4.725 0 0 1-5.57-4.648V1.99A1.042 1.042 0 0 1 4.005.949h8.075a1.042 1.042 0 0 1 1.041 1.041v.5Zm3.028-.5v.3a2.146 2.146 0 0 0-2.082 0v-.3a1.975 1.975 0 0 0-.3-1.041h2.672a1.974 1.974 0 0 0-.288 1.041Zm11.1 1.342a4.725 4.725 0 0 1-5.571 4.648 5.58 5.58 0 0 1-4.584-5.492v-.5A1.042 1.042 0 0 1 18.132.944h8.074a1.042 1.042 0 0 1 1.041 1.041v1.342Zm2.019-.837a.537.537 0 0 1-.536.536H28.2V1.956h1.042a.031.031 0 0 1 .032.031v.5Z"
        />
        <path
            data-name="Path 814"
            d="M11.567 3.023a.473.473 0 0 0-.575.342 3.564 3.564 0 0 1-2.819 2.627 2.778 2.778 0 0 1-.5.045.473.473 0 1 0 0 .946 3.719 3.719 0 0 0 .664-.06 4.51 4.51 0 0 0 3.572-3.328.473.473 0 0 0-.342-.572Z"
        />
        <path
            data-name="Path 815"
            d="M25.705 2.855a.473.473 0 0 0-.473.473 2.7 2.7 0 0 1-2.7 2.708 2.786 2.786 0 0 1-.5-.046.473.473 0 0 0-.169.931 3.736 3.736 0 0 0 .666.061 3.652 3.652 0 0 0 3.641-3.654.473.473 0 0 0-.465-.473Z"
        />
    </svg>
);
export default SvgOptics;
